import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";
import apiClient from "utils/apiClient";

const CARDS = [
  { key: "total_users", label: "Total Users", icon: "people_alt", color: "#5c6bc0", bg: "#eef0fb" },
  {
    key: "active_this_week",
    label: "Active This Week",
    icon: "bolt",
    color: "#0ea5e9",
    bg: "#e0f4fd",
  },
  {
    key: "new_this_week",
    label: "New This Week",
    icon: "person_add",
    color: "#10b981",
    bg: "#d1fae5",
  },
  {
    key: "total_recipes",
    label: "Total Recipes",
    icon: "restaurant_menu",
    color: "#f59e0b",
    bg: "#fef3c7",
  },
  {
    key: "total_goals",
    label: "Total Goals",
    icon: "emoji_events",
    color: "#8b5cf6",
    bg: "#ede9fe",
  },
  { key: "avg_level", label: "Avg Level", icon: "trending_up", color: "#ec4899", bg: "#fce7f3" },
  {
    key: "avg_streak",
    label: "Avg Streak (days)",
    icon: "local_fire_department",
    color: "#ef4444",
    bg: "#fee2e2",
  },
];

function StatCard({ label, value, icon, color, bg }) {
  return (
    <Box
      sx={{
        bgcolor: "#fff",
        borderRadius: "14px",
        p: 2.5,
        display: "flex",
        alignItems: "center",
        gap: 2,
        boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)",
      }}
    >
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: "12px",
          bgcolor: bg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Icon sx={{ color, fontSize: "1.3rem !important" }}>{icon}</Icon>
      </Box>
      <Box>
        <Typography variant="h5" fontWeight={700} sx={{ color: "#111827", lineHeight: 1.1 }}>
          {value ?? "—"}
        </Typography>
        <Typography variant="caption" sx={{ color: "#6b7280", fontWeight: 500 }}>
          {label}
        </Typography>
      </Box>
    </Box>
  );
}

StatCard.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  bg: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

StatCard.defaultProps = {
  value: null,
};

function AdminAnalytics() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    apiClient
      .get("/api/admin/analytics")
      .then((r) => setData(r.data))
      .catch(() => setError("Failed to load analytics"));
  }, []);

  if (error)
    return (
      <Typography color="error" variant="body2">
        {error}
      </Typography>
    );

  if (!data)
    return (
      <Typography variant="body2" color="text.secondary">
        Loading…
      </Typography>
    );

  return (
    <Grid container spacing={2}>
      {CARDS.map((c) => (
        <Grid item xs={12} sm={6} lg={4} key={c.key}>
          <StatCard label={c.label} value={data[c.key]} icon={c.icon} color={c.color} bg={c.bg} />
        </Grid>
      ))}
    </Grid>
  );
}

export default AdminAnalytics;
